import { Link } from 'react-router-dom';

export function Categories() {
  const categories = [
    {
      icon: 'ri-anchor-line',
      title: '어구류',
      description: '그물, 로프, 부표 등 어업에 필요한 모든 어구',
      items: ['트롤 그물', '자망', '로프', '부표', '어구 부속품'],
      color: 'from-blue-500 to-cyan-500',
    },
    {
      icon: 'ri-ship-line',
      title: '갑판용품',
      description: 'Wire, Block, Shackle 등 갑판 작업 필수품',
      items: ['Wire Rope', 'Block', 'Shackle', '체인', '갑판 부속품'],
      color: 'from-ocean-500 to-blue-600',
    },
    {
      icon: 'ri-settings-3-line',
      title: '기관물품',
      description: '엔진 부품, 필터, 오일 등 기관 관련 물품',
      items: ['엔진 부품', '필터', '오일', '냉각 시스템', '전기 부품'],
      color: 'from-teal-500 to-emerald-500',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            주요 카테고리
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            어선 운영에 필요한 모든 물품을 체계적으로 분류하여 제공합니다
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {categories.map((category, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border-2 border-gray-200 p-8 hover:border-ocean-400 hover:shadow-xl transition-all duration-300 group"
            >
              {/* Icon */}
              <div className={`w-16 h-16 bg-gradient-to-br ${category.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${category.icon} text-white text-3xl`}></i>
              </div>

              {/* Title & Description */}
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {category.title}
              </h3>
              <p className="text-gray-600 mb-6">
                {category.description}
              </p>

              {/* Items List */}
              <ul className="space-y-2 mb-6">
                {category.items.map((item, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-checkbox-circle-fill text-ocean-500"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              {/* CTA Button */}
              <Link
                to="/products"
                className="inline-flex items-center gap-2 text-ocean-600 font-semibold hover:gap-3 transition-all whitespace-nowrap"
              >
                <span>제품 보기</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center">
          <Link
            to="/products"
            className="inline-flex items-center gap-3 px-8 py-4 bg-ocean-600 text-white rounded-xl hover:bg-ocean-700 transition-colors font-semibold text-lg whitespace-nowrap"
          >
            <span>전체 제품 카탈로그 보기</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}